<!-- Hero Section -->
<div class="healthcare-section-bg">
  <section class="healthcare-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <h1 class="healthcare-heading mb-3">
            AI-Powered Healthcare Software Development Solutions
          </h1>
          <!-- <p class="healthcare-subheading1 mb-4">
            Health Care Industries
          </p> -->
          <p class="healthcare-subheading2 mb-4">
            We accelerate healthcare innovation through AI-powered custom software development that reduces
            administrative burden, streamlines clinical workflows, and improves patient outcomes. Deploy
            production-ready healthcare software significantly faster with our AI-accelerated development approach.
          </p>
          <!-- <p class="healthcare-subheading3 mb-4">
            We optimize your healthcare workflows through our custom-built software solutions.
          </p> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <button class="btn hire-btn hire" (click)="bookAFreeCall()">
              Book a Free Consultation
            </button>
          </div>
        </div>

        <div class="col-lg-6 text-center">
          <img src="../../../../assets/industries/healthcare/capsule.png" alt="Health Care Capsule"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
  <div class="container">
    <div class="section-header text-center mx-auto">
      <h2>Why HealthTech Innovation matters today</h2>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="solutions-image-container">
          <div class="solution-image-card image-one">
            <div class="image-overlay"></div>
            <img src="../../../../assets/industries/healthcare/healthtech-img1.png" alt="Team collaborating on computer">
          </div>
          <div class="solution-image-card image-two">
            <div class="image-overlay"></div>
            <img src="../../../../assets/industries/healthcare/healthtech-img2.png" alt="Two colleagues looking at a laptop">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="solutions-content">
          <p>
            Healthcare organizations waste an average of 25% of staff time on manual data entry, experience 15-20%
            revenue leakage from billing inefficiencies, and face increasing regulatory complexity. Manual processes,
            fragmented patient data across 8-12 disparate systems, and outdated legacy technology continue to slow down
            healthcare workflows, directly impacting patient safety, operational costs, and staff burnout.
          </p>
          <p>
            At Kalpita Technologies, we address these challenges through end-to-end healthcare software development,
            delivering secure, scalable, and intelligent solutions, from patient management software solutions to
            healthcare SaaS platforms designed for hospitals, clinics, and digital health providers.
          </p>
          <p>Here are some key benefits of advanced HealthTech solutions:</p>
          <div class="features-list">
            <ul>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">AI-driven predictive analytics for
                proactive care</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Improved operational efficiency &
                faster patient workflows</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Enhanced accuracy in clinical and
                administrative tasks</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Centralized and secure data
                management</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Better patient engagement & care
                coordination</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Real-time dashboards for clinical
                and operational insights</li>
              <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Scalable digital systems built for
                long-term growth</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
  <div class="container">
    <div class="text-center">
      <h2 class="impact-heading">Kalpita Technologies’ HealthTech Solutions</h2>
    </div>
    <div class="row align-items-center impact-main-content">
      <!-- Added animation trigger -->
      <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">
        <!-- Added animate-item class -->
        <p class="impact-description animate-item">
          We deliver custom HealthTech software solutions that elevate your Healthcare operations and workflows tailored
          to your business model. Examples of such solutions and services are AI-based web development (Intelligent
          patient portals), HIPAA-compliant mobile app development, UI/UX Design for Clinician-optimized interfaces, and
          QA & Testing (Security, Compliance Validation, and clinical workflow verification), which deliver measurable
          ROI such as:
        </p>
        <!-- Added animate-item class -->
        <ul class="simple-impact-list animate-item">
          <li>
            30% Increase in Operational Efficiency – e.g. reduced hospital wait-times
          </li>
          <li>
            50% Faster Custom Reporting – e.g. Real-time dashboards replacing manual report generation
          </li>
          <li>
            30% Error Reduction – e.g. Automated medication reconciliation
          </li>
        </ul>
      </div>
      <div class="col-lg-6">
        <div class="impact-image-wrapper">
          <img src="../../../../assets/industries/healthcare/healthtech-solutions-img.png"
            alt="Developer working on multiple screens">
          <!-- Added Shine Effect -->
          <div class="shine"></div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
  <div class="container">

    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-8">
        <h2 class="section-heading">Real-World Impact: HealthTech Case Studies</h2>
        <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
      </div>
    </div>

    <!-- Slider Wrapper -->
    <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

      <div class="slider-viewport">
        <div class="slider-track" [style.transform]="getTransform()"
          [style.transition]="isDragging ? 'none' : 'transform 0.6s cubic-bezier(0.4,0,0.2,1)'"
          (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()"
          (mouseleave)="onMouseUp()" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd()">

          <div class="case-study-slide" *ngFor="let study of caseStudies">
            <div class="row align-items-center">
              <div class="col-lg-5 d-flex justify-content-center">
                <div class="case-study-image-wrapper">
                  <img [src]="study.image" [alt]="study.title" class="img-fluid">
                </div>
              </div>

              <div class="col-lg-7">
                <div class="case-study-content">
                  <h3 class="case-study-title">{{ study.title }}</h3>
                  <p class="case-study-description">{{ study.description }}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="slider-dots">
        <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
          (click)="goToSlide(i)">
        </span>
      </div>

    </div>

  </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
  <section class="healthcare-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <h2 class="healthcare-heading mb-3">
            What Our Clients Say
          </h2>
          <div class="mb-5 contact-btn">
            <button class="btn hire-btn hire" (click)="testimonials()">
              Read Our Client Stories
            </button>
          </div>
        </div>

        <div class="col-lg-6 text-center">
          <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
            class="img-fluid testimonial-hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="healthCareFaqs"></app-faq>
<!-- Final CTA -->
<!-- Final CTA -->
<div class="final-cta-bg">
  <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule" class="cta-capsule-img">
  <section id="final-cta" class="final-cta-section container">
    <div class="section-header text-center mx-auto">
      <!-- <h2>Final CTA</h2> -->
    </div>
    <div class="row align-items-center">
      <div class="col-lg-6 cta-content-col">
        <h2 class="cta-heading-small">Let’s Build the Future of Healthcare Together</h2>
        <!-- <h1 class="cta-heading-large mb-3">Health Care Industry?</h1>
        <p class="cta-subheading mb-4">
          Let’s build software that’s made for YOU, not everyone else. 
        </p> -->
        <div class="mb-5 cta-btn-group">
          <button class="btn btn-schedule-demo" (click)="bookAFreeCall()">
            Schedule Your Free Consultation
          </button>
        </div>
      </div>
      <div class="col-lg-6 text-center">
        <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
          class="img-fluid cta-clinic-image">
      </div>
    </div>
  </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>